import { useMemo } from 'react'

import { CircleQuestionMark } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'

import { useICStreamContext } from '@/pages/funds/ic-report/ic-report-context.context'
import { GenericSectionChild } from '@/pages/funds/ic-report/sections'

export type ICReportWidgetProps = {
  widget: GenericSectionChild
  widgetButtons?: React.ReactElement[]
}

export const ICReportWidget = ({ widget, widgetButtons }: ICReportWidgetProps) => {
  const { params } = useICStreamContext()

  const query = widget.query!(params)
  const Component = widget.component

  const labels = useMemo(() => {
    if (params.fund_name) {
      return widget.labels({ fund_name: params.fund_name })
    }
    return undefined
  }, [widget.labels, params.fund_name])

  return (
    <Widget id={`icr_${widget.key}`} className={cn('scroll-mt-0')}>
      <WidgetHeaderWithQuery query={query} title={labels?.widgetTitle} buttons={widgetButtons} />
      <WidgetContent loading={query.isLoading}>
        {labels?.descriptions?.widget && (
          <div className="flex items-center gap-2 px-3 py-2 text-sm border-b bg-sidebar text-muted-foreground">
            <CircleQuestionMark size={16} className={'text-blue-600 shrink-0'} />
            {labels.descriptions?.widget}
          </div>
        )}
        <Component params={params} />
      </WidgetContent>
    </Widget>
  )
}
